export default __webpack_public_path__ + "static/jt_logo_new-abeceff4cd302b5c3be40907dbd4a1a3.png";